import moment from "moment";

/**
 * The pick deadline, as a player reads it. SUR-441.
 *
 * The submission deadline — PromoPeriod.entry_end_time — never the event window
 * end, which can be days later and would tell a player they have longer than
 * they do.
 *
 * One definition because three screens show it: the entry manager, the pick
 * screen and the pool board. A deadline that reads differently depending on
 * which screen you are looking at is worse than no deadline at all.
 */
export function formatPickDeadline(iso){
    if(!iso) return "";
    return moment(iso).format("ddd MMM D, h:mm A");
}

/**
 * "Week 2 — pick by Tue Aug 18, 1:39 PM", or just the week when there is no
 * deadline to name.
 */
export function periodAndDeadline(name, iso){
    let when = formatPickDeadline(iso);
    if(!name) return when;
    return when ? `${name} — pick by ${when}` : name;
}
